// extracted by mini-css-extract-plugin
var _1 = "src-pages-dashboard-components-empty-state-__verticalCenter--wsm_VAr9gaE7kAFflNoK";
export { _1 as "verticalCenter" }
